<template>
  <ReaderInterludeEnd
    class="sm:max-w-screen-sm md:max-w-screen-md lg:max-w-screen-lg mx-auto"
    :cardClass
    @return="emit('return')"
    @openComments="emit('openComments')"
  >
    <template v-if="title" #return>
      <TitleCard v-if="title" :title />
    </template>
    <template v-if="chapter && title" #share>
      <NovelChapterShareBlock :chapter="chapter" :title="title" />
    </template>
    <template #comments>
      <FeedComments
        class="p-2 -m-2"
        :feed-id="chapter?.id ?? ''"
        feed-type="novel_chapter"
        preview
        collapse-replies
      />
    </template>
  </ReaderInterludeEnd>
</template>

<script setup lang="ts">
import { type NovelChapterEntity, type TitleEntity } from "~/src/api";

const { title } = defineProps<{
  chapter?: NovelChapterEntity;
  title?: TitleEntity;
  cardClass?: string;
}>();

const emit = defineEmits<{
  (e: "return"): void;
  (e: "openComments"): void;
}>();
</script>

<style scoped lang="postcss"></style>
